import { APICore } from "./apiCore";

const api = new APICore();

interface VendorAnalyticsFilters {
    stallId?: number;
    festivalEvent?: number;
    fromDate?: string;
    toDate?: string;
}

// Get Vendor Dashboard
function getVendorDashboard(vendorId: number) {
    return api.get(`/vendors/${vendorId}/dashboard`, "");
}

// Get Vendor Analytics
function getVendorAnalytics(
    vendorId: number,
    params?: VendorAnalyticsFilters
) {
    return api.get(`/vendors/${vendorId}/analytics`, params || {});
}

// Get Vendors
function getVendors(params: {
    page: number;
    limit: number;
    sortType?: string;
}) {
    return api.get("/vendors", params);
}

// Get Vendor By Id
function getVendorById(vendorId: number) {
    return api.get(`/vendors/${vendorId}`, "");
}

// Create Vendor
function createVendor(payload: any) {
    return api.create("/vendors", payload);
}

// Update Vendor
function updateVendor(vendorId: number, payload: any) {
    return api.updatePatch(`/vendors/${vendorId}`, payload);
}

// Delete Vendor
function deleteVendor(vendorId: number) {
    return api.delete(`/vendors/${vendorId}`);
}

export {
    getVendors,
    getVendorById,
    createVendor,
    updateVendor,
    deleteVendor,
    getVendorDashboard,
    getVendorAnalytics,
};